import { useLocalObservable } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';

import { parseToTree, IUserMention, IKeyWord } from '@gem/modules/markdown';

import { renderTree } from './renderTree/renderTree';

export interface ITextRendererParams {
  children: string;
  groupId?: string;
  userMentions?: IUserMention[];
  keyWords?: IKeyWord[];
  hasBotCommands?: boolean;
  isPlainText?: boolean;
}

interface ITextRendererPresenter {
  content: ReactElement | null;
  setContent(content: ReactElement): void;
}

export const useTextRendererPresenter = (data: ITextRendererParams): ITextRendererPresenter => {
  const { children, groupId, userMentions, keyWords, hasBotCommands, isPlainText } = data;

  const presenter = useLocalObservable<ITextRendererPresenter>(() => ({
    content: null,

    setContent(content: ReactElement): void {
      presenter.content = content;
    },
  }));

  useEffect(() => {
    const tree = parseToTree({
      text: children,
      userMentions,
      keyWords,
      hasBotCommands,
      isPlainText,
    });
    presenter.setContent(renderTree(tree, { groupId }));
  }, [children, userMentions, keyWords, hasBotCommands, isPlainText, groupId]);

  return presenter;
};
